import { useEffect } from 'react';
import { ensureAiHealth } from './aiAvailabilityStore';

const POLL_MS = 30_000;

const POLL_ENABLED = false;

export function useAiAvailabilityPoll(): void {
  useEffect(() => {
    void ensureAiHealth();
    if (!POLL_ENABLED) return;
    const t = setInterval(() => void ensureAiHealth({ refresh: true }), POLL_MS);
    return () => clearInterval(t);
  }, []);
}
